import useFetch from '@components/_hooks/useFetch';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const NEW_QUOTE_OPENED = 'new_quote_opened';
export const QUOTE_OPENED = 'quote_opened';
export const QUOTE_CREATED = 'quote_created';
export const QUOTE_SAVED = 'quote_saved';
export const QUOTE_EDITED = 'quote_edited';
export const QUOTE_PAYMENT = 'quote_payment';
export const ORDER_PAYMENT = 'order_payment';
export const QUOTE_PAID = 'quote_paid';
export const ORDER_PAID = 'order_paid';
export const ORDER_OPENED = 'order_opened';
export const PDF_OPENED = 'pdf_opened';
export const PDF_DOWNLOADED = 'pdf_downloaded';
export const CARRIAGE_OPENED = 'carriage_opened';
export const CARRIAGE_TRACKING_CLICKED = 'carriage_tracking_clicked';
export const USER_ACCOUNT_CREDIT_APPLICATION_CLICKED = 'user_account_credit_application_clicked';
export const USER_ACCOUNT_CREDIT_APPLICATION_SUBMITTED = 'user_account_credit_application_submitted';
export const CHECKOUT_DETAILS_VISITED = 'checkout_details_visited';
export const OTP = 'otp';
export const AUTH = 'auth';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const ADDRESSES = 'addresses';
export const ADDRESS_CREATED = 'address_created';
export const ADDRESS_EDITED = 'address_edited';

export const ENTITY_ACTIONS = {
    NEW_QUOTE_OPENED,
    QUOTE_OPENED,
    QUOTE_CREATED,
    QUOTE_SAVED,
    QUOTE_EDITED,
    QUOTE_PAYMENT,
    ORDER_PAYMENT,
    QUOTE_PAID,
    ORDER_PAID,
    ORDER_OPENED,
    PDF_OPENED,
    PDF_DOWNLOADED,
    CARRIAGE_OPENED,
    CARRIAGE_TRACKING_CLICKED,
    USER_ACCOUNT_CREDIT_APPLICATION_CLICKED,
    USER_ACCOUNT_CREDIT_APPLICATION_SUBMITTED,
    CHECKOUT_DETAILS_VISITED,
    OTP,
    AUTH,
    LOGIN,
    LOGOUT,
    ADDRESSES,
    ADDRESS_CREATED,
    ADDRESS_EDITED,
};

// Action Groups
export const ACTION_GROUP_QUOTE = 'quote';
export const ACTION_GROUP_ORDER = 'order';
export const ACTION_GROUP_CHECKOUT = 'checkout';
export const ACTION_GROUP_PAYMENT = 'payment';
export const ACTION_GROUP_CARRIAGE = 'carriage';
export const ACTION_GROUP_CREDIT = 'credit';
export const ACTION_GROUP_USER_ACCOUNT = 'user_account';
export const ACTION_GROUP_OTP = 'otp';
export const ACTION_GROUP_AUTH = 'auth';
export const ACTION_GROUP_ADDRESSES = 'addresses';

export const ACTION_GROUPS = {
    QUOTE: ACTION_GROUP_QUOTE,
    ORDER: ACTION_GROUP_ORDER,
    CHECKOUT: ACTION_GROUP_CHECKOUT,
    PAYMENT: ACTION_GROUP_PAYMENT,
    CARRIAGE: ACTION_GROUP_CARRIAGE,
    CREDIT: ACTION_GROUP_CREDIT,
    USER_ACCOUNT: ACTION_GROUP_USER_ACCOUNT,
    OTP: ACTION_GROUP_OTP,
    AUTH: ACTION_GROUP_AUTH,
    ADDRESSES: ACTION_GROUP_ADDRESSES,
};

// Entity Types
export const ENTITY_TYPE_QUOTE = 'quote';
export const ENTITY_TYPE_ORDER = 'order';
export const ENTITY_TYPE_USER = 'user';
export const ENTITY_TYPE_PAGE_VIEW = 'page_view';
export const ENTITY_TYPE_CARRIAGE = 'carriage';
export const ENTITY_TYPE_CREDIT = 'credit';
export const ENTITY_TYPE_USER_ACCOUNT = 'customer';
export const ENTITY_TYPE_CHECKOUT = 'checkout';
export const ENTITY_TYPE_OTP = 'otp';
export const ENTITY_TYPE_AUTH = 'auth';
export const ENTITY_TYPE_ADDRESSES = 'addresses';

export const ENTITY_TYPES = {
    QUOTE: ENTITY_TYPE_QUOTE,
    ORDER: ENTITY_TYPE_ORDER,
    USER: ENTITY_TYPE_USER,
    PAGE_VIEW: ENTITY_TYPE_PAGE_VIEW,
    CARRIAGE: ENTITY_TYPE_CARRIAGE,
    CREDIT: ENTITY_TYPE_CREDIT,
    USER_ACCOUNT: ENTITY_TYPE_USER_ACCOUNT,
    CHECKOUT: ENTITY_TYPE_CHECKOUT,
    OTP: ENTITY_TYPE_OTP,
    AUTH: ENTITY_TYPE_AUTH,
    ADDRESSES: ENTITY_TYPE_ADDRESSES,
};

// Senior Pattern: Registry mapping action types to default metadata (action_group, entity_type)
export const ACTION_CONFIG = {
    [NEW_QUOTE_OPENED]: {
        action_group: ACTION_GROUPS.QUOTE,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [QUOTE_OPENED]: {
        action_group: ACTION_GROUPS.QUOTE,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [QUOTE_CREATED]: {
        action_group: ACTION_GROUPS.QUOTE,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [QUOTE_SAVED]: {
        action_group: ACTION_GROUPS.QUOTE,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [QUOTE_EDITED]: {
        action_group: ACTION_GROUPS.QUOTE,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [QUOTE_PAYMENT]: {
        action_group: ACTION_GROUPS.PAYMENT,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [ORDER_PAYMENT]: {
        action_group: ACTION_GROUPS.PAYMENT,
        entity_type: ENTITY_TYPES.ORDER,
    },
    [QUOTE_PAID]: {
        action_group: ACTION_GROUPS.PAYMENT,
        entity_type: ENTITY_TYPES.QUOTE,
    },
    [ORDER_PAID]: {
        action_group: ACTION_GROUPS.PAYMENT,
        entity_type: ENTITY_TYPES.ORDER,
    },
    [ORDER_OPENED]: {
        action_group: ACTION_GROUPS.ORDER,
        entity_type: ENTITY_TYPES.ORDER,
    },
    [CARRIAGE_OPENED]: {
        action_group: ACTION_GROUPS.CARRIAGE,
        entity_type: ENTITY_TYPES.CARRIAGE,
    },
    [CARRIAGE_TRACKING_CLICKED]: {
        action_group: ACTION_GROUPS.CARRIAGE,
        entity_type: ENTITY_TYPES.CARRIAGE,
    },
    [USER_ACCOUNT_CREDIT_APPLICATION_CLICKED]: {
        action_group: ACTION_GROUPS.USER_ACCOUNT,
        entity_type: ENTITY_TYPES.USER_ACCOUNT,
    },
    [USER_ACCOUNT_CREDIT_APPLICATION_SUBMITTED]: {
        action_group: ACTION_GROUPS.USER_ACCOUNT,
        entity_type: ENTITY_TYPES.USER_ACCOUNT,
    },
    [CHECKOUT_DETAILS_VISITED]: {
        action_group: ACTION_GROUPS.CHECKOUT,
        entity_type: ENTITY_TYPES.CHECKOUT,
    },
    [OTP]: {
        action_group: ACTION_GROUPS.OTP,
        entity_type: ENTITY_TYPES.OTP,
    },
    [AUTH]: {
        action_group: ACTION_GROUPS.AUTH,
        entity_type: ENTITY_TYPES.AUTH,
    },
    [LOGIN]: {
        action_group: ACTION_GROUPS.AUTH,
        entity_type: ENTITY_TYPES.AUTH,
    },
    [LOGOUT]: {
        action_group: ACTION_GROUPS.AUTH,
        entity_type: ENTITY_TYPES.AUTH,
    },
    [ADDRESSES]: {
        action_group: ACTION_GROUPS.ADDRESSES,
        entity_type: ENTITY_TYPES.ADDRESSES,
    },
    [ADDRESS_CREATED]: {
        action_group: ACTION_GROUPS.ADDRESSES,
        entity_type: ENTITY_TYPES.ADDRESSES,
    },
    [ADDRESS_EDITED]: {
        action_group: ACTION_GROUPS.ADDRESSES,
        entity_type: ENTITY_TYPES.ADDRESSES,
    },
};

export default function useUserAccountAction() {
    const { post } = useFetch(false)
    const { isAuthenticated, user } = useSelector(state => state.authReducer);
    const agentReducer = useSelector(state => state.agentReducer);

    // Required here to avoid infinite loop
    const isAgent = () => {
        if (agentReducer?.user_state == 'Agent' || agentReducer?.user_state == 'SuperUser') {
            return true;
        }
        else if (agentReducer?.user_state == 'User') {
            return false
        }
        else {
            return user?.role == 'Agent' ? true : false;
        }
    }

    const is_agent = isAgent();
    const trackAction = useCallback(async ({
        action_type,
        action_group = null,
        url = null,
        entity_type = null,
        entity_id = null,
        metadata = null,
    }, allow_agent = false) => {
        if (!isAuthenticated && action_type !== OTP && action_type !== AUTH && action_type !== CHECKOUT_DETAILS_VISITED) return;
        if (is_agent && !allow_agent) return;

        // Resolve default action_group and entity_type from configuration if not explicitly provided
        const config = ACTION_CONFIG[action_type] || {};
        const resolvedGroup = action_group || config.action_group || null;
        const resolvedEntityType = entity_type || config.entity_type || null;

        return await post('dashboard/account/track-action', {
            action_type,
            action_group: resolvedGroup,
            url: url || window.location.pathname,
            entity_type: resolvedEntityType,
            entity_id,
            metadata,
        }, false, false)
    }, [post]);

    return {
        trackAction,
    };
}